import type { AnimationGroup, DeepPartial } from "@/types";

export const animationOverrides: Record<
  string,
  Record<string, DeepPartial<AnimationGroup>>
> = {
  // Red Dragon
  "05701": {
    dragonMaxRoll: {
      targetedAnimations: [
        {
          animation: {
            name: "scale",
            keys: [
              {},
              {
                frame: 10,
                // doubling the scale to correct the dragon size against the die
                values: [200, 200, 200],
              },
            ],
          },
        },
      ],
    },
  },
  // Themberchaud
  "04601": {
    dragonMaxRoll: {
      targetedAnimations: [
        {
          animation: {
            name: "scale",
            keys: [
              {},
              {
                frame: 10,
                // doubling the scale to correct the dragon size against the die
                values: [40, 40, 40],
              },
            ],
          },
        },
      ],
    },
  },
  // Upside Down
  "07501": {
    fuzUVOffset: {
      targetedAnimations: [
        {
          targetId: "Clone of d4_Fuzz.d4_Fuzz",
        },
      ],
    },
    rollCompleteFuz: {
      targetedAnimations: [
        {},
        {
          targetId: "Clone of d4_primitive2.d4_primitive2",
        },
        {},
        {
          targetId: "Clone of d6_primitive2.d6_primitive2",
        },
        {},
        {},
        {},
        {
          targetId: "Clone of d10_primitive2.d10_primitive2",
        },
        {},
        {},
        {},
        {},
        {},
        {
          targetId: "Clone of d00_primitive2.d00_primitive2",
        },
      ],
    },
  },
};
